import { render } from "./AppForm.vue?vue&type=template&id=a350924c"
const script = {}

import exportComponent from "/home/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__